import { Data } from 'cio/utils/analytics/transforms';
import { Periods } from 'cio/utils/metrics/common';

const PeriodLabels = {
  week: '7 Days',
  [Periods.DAYS]: '30 Days',
  [Periods.WEEKS]: '12 Weeks',
  [Periods.MONTHS]: '12 Months',
  [Periods.ALL_TIME]: 'All Time',
  [Periods.CUSTOM]: 'Custom',
};

export function calculateTimeRangeDays(data: Data) {
  return data.timeRange.end.diff(data.timeRange.start, 'days') + 1;
}

export function generateFilteredTimeFrameData(data: Data) {
  return {
    'Filtered Timeframe': (PeriodLabels as any)[data.timePeriod],
    'Filtered Timeframe Length': calculateTimeRangeDays(data),
  };
}
